import { render, staticRenderFns } from "./ShowEditContent.vue?vue&type=template&id=cb812642&scoped=true&"
import script from "./ShowEditContent.vue?vue&type=script&lang=js&"
export * from "./ShowEditContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb812642",
  null
  
)

export default component.exports